<template>
  <section class="product-details-col product-details-params">
    <dl class="text-xs">
      <template v-for="(parameter, index) in parameters">
        <dt :key="'dt-' + index" v-if="checkParams(parameter.values)">
          {{parameter.label}}
        </dt>
        <dd :key="'dd-' + index" class="accent" >
          {{parameter.values.join(', ')}}
        </dd>
      </template>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'productParameters',
  props: {
    parameters: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    checkParams (values) {
      let retVal = false

      if (values.length) {
        if (values[0] && values[0].length) {
          retVal = true
        }
      }

      return retVal
    }
  }
}
</script>

<style scoped lang="scss">
</style>
